import consumer from "./consumer"

export function subscribeToMarketPrices(marketId, callbacks) {
  return consumer.subscriptions.create(
    { channel: "MarketPricesChannel", market_id: marketId },
    {
      received(data) {
        if (callbacks.received) callbacks.received(data)
      },
      connected() {
        if (callbacks.connected) callbacks.connected()
      },
      disconnected() {
        if (callbacks.disconnected) callbacks.disconnected()
      }
    }
  )
}
